// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgEgg = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="309 206 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.eg-1 {
  fill: #ffa600;
  stroke: #1d1d1b;
}

.eg-1,
.eg-2 {
  stroke-width: 0.25px;
}

.eg-1,
.eg-2,
.eg-3,
.eg-4 {
  stroke-miterlimit: 10;
}

.eg-2 {
  stroke: #fff;
}

.eg-5,
.eg-4 {
  fill: #fff;
}

.eg-6 {
  fill: #484747;
}

.eg-7 {
  fill: #f39ee5;
}

.eg-3,
.eg-4 {
  stroke: #000;
  stroke-width: 0.5px;
}

.eg-8 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}

.eg-9 {
  fill: #1d1d1b;
}
`}</style>
    </defs>
    <path
      className="eg-5"
      d="M524.82,315.5c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.52.35-1.04.69-1.56,1.03-.47.31-.94.61-1.42.9-.19.12-.38.23-.57.35-13.63,8.38-29.3,13.75-46.11,15.16-2.97.26-5.97.39-9.01.39-.31,0-.61,0-.92-.01-1.17,0-2.34-.03-3.51-.09-18.62-.76-35.99-6.36-50.89-15.57-.26-.16-.53-.32-.79-.49-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-57.91,46.7-104.93,104.49-105.42.31-.01.62-.01.93-.01,58.23,0,105.43,47.21,105.43,105.43Z"
    />
    <path
      className="eg-8"
      d="M524.82,315.5c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.46.31-.92.61-1.38.91-.06.04-.12.08-.18.12-.47.31-.94.61-1.42.9-13.76,8.58-29.64,14.08-46.68,15.51-2.66.23-5.35.36-8.07.38-.31.01-.63.01-.94.01-1.48,0-2.96-.03-4.43-.1-17.72-.72-34.30-5.83-48.71-14.26-1-.58-1.99-1.18-2.97-1.80-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08,0,0,0-.01-.02-.01-.24-.17-.50-.32-.74-.50-28.26-18.90-46.88-51.12-46.88-87.68,0-58.22,47.20-105.43,105.42-105.43.31,0,.62,0,.93.01,57.80.49,104.50,47.51,104.50,105.42Z"
    />
    <path d="M495.17,361.14c.58-1.85-6.64-10.87-11.64-16.98-5-6.08-10.36-12.79-15.78-18.03-2.22-2.15-5.45-5.09-8.46-7.79-.66-.62-1.31-1.20-1.94-1.76-2.09-1.85-3.91-3.46-5.05-4.46-.76-.67-1.19-1.06-1.19-1.06,0,0-1.38,12.14-.70,17.53.02.17.04.31.07.47.74,5.36,2.89,12.51,6.94,17.37.70.84,1.41,1.60,2.17,2.32.45.42.91.85,1.38,1.25.44.38.95.77,1.48,1.18.69.55,1.39,1.06,2.10,1.58.11.06.21.15.32.24.29.20.55.40.83.60,1.57,1.10,3.16,2.22,4.77,3.52.24.17.46.36.69.55.27.24.52.45.77.66,5.18,4.50,12.49,11.57,14.38,10.90,1.90-.68,8.29-6.25,8.85-8.11Z" />
    <path d="M345.48,361.14c-.58-1.85,6.64-10.87,11.64-16.98,5-6.08,10.36-12.79,15.78-18.03,2.22-2.15,5.45-5.09,8.46-7.79.66-.62,1.31-1.20,1.94-1.76,2.09-1.85,3.91-3.46,5.05-4.46.76-.67,1.19-1.06,1.19-1.06,0,0,1.38,12.14.70,17.53-.02.17-.04.31-.07.47-.74,5.36-2.89,12.51-6.94,17.37-.70.84-1.41,1.60-2.17,2.32-.45.42-.91.85-1.38,1.25-.44.38-.95.77-1.48,1.18-.69.55-1.39,1.06-2.10,1.58-.11.06-.21.15-.32.24-.29.20-.55.40-.83.60-1.57,1.10-3.16,2.22-4.77,3.52-.24.17-.46.36-.69.55-.27.24-.52.45-.77.66-5.18,4.50-12.49,11.57-14.38,10.90-1.90-.68-8.29-6.25-8.85-8.11Z" />
    <path
      className="eg-5"
      d="M475.75,404.01c-.10.46-.21.92-.31,1.37-13.63,8.38-29.30,13.75-46.11,15.16-2.97.26-5.97.39-9.01.39-.31,0-.61,0-.92-.01-.31.01-.63.01-.94.01-1.48,0-2.96-.03-4.43-.10-17.72-.72-34.30-5.83-48.71-14.26-.11-.43-.22-.87-.32-1.31-2.10-8.97-2.46-18.67-.53-28.70,1.19-6.19,2.57-12.27,4.17-18.15.82-3.06,1.71-6.07,2.66-9.01,4.64-14.40,10.69-27.09,18.45-36.34.06-.08.13-.16.20-.24,8.19-9.68,18.27-15.53,30.54-15.53h.16c12.03.05,22.12,5.52,30.36,14.74.45.51.91,1.03,1.35,1.57,7.40,8.87,13.24,20.84,17.59,34.61.04.13.08.26.12.39,1.09,3.46,2.08,7.04,2.97,10.71,1.37,5.56,2.52,11.33,3.47,17.25,1.53,9.60,1.13,18.85-.76,27.45Z"
    />
    <path
      className="eg-3"
      d="M470.27,348.21c-8.79,17.98-27.71,30.41-49.62,30.41s-40-11.90-49.02-29.23c9.55-29.70,25.17-52.11,49.18-52.11s40.09,21.29,49.46,50.93Z"
    />
    <path
      className="eg-2"
      d="M455.79,305.03s.07-.01.07-.01c-4.73,14.90-14.89,24.62-18.10,35.31-4.29,14.23-5.58,28.87-6.80,30.19-2.44,2.62-17.04,2.62-20.28,0-1.63-1.32-1.13-15.21-5.98-27.85-5.51-14.32-6.30-16.46-13.39-27.45.01-.03.03-.07.07-.10-4.29-6.53-10.31-18.67-10.31-29.71,0-24.69,17.63-44.71,39.36-44.71s39.36,20.02,39.36,44.71c0,7.04-1.43,13.70-4,19.62Z"
    />
    <g>
      <path
        className="eg-7"
        d="M390.65,299.84c1.27-.52,2.12-1.04,2.63-2.31.51-1.26.26-2.23-.29-3.48-.55-1.25-1.91-2.41-3.07-2.91-1.16-.50-1.97-.68-3.22-.45-1.25.23-3.19,1.46-3.66,2.74-.47,1.28-.26,2.23.29,3.48.55,1.25,1.53,2.30,3.07,2.91,1.54.62,2.97.54,4.24.02Z"
      />
      <path
        className="eg-7"
        d="M449.95,299.79c-1.28-.50-2.14-1-2.68-2.25-.54-1.25-.30-2.22.22-3.48.53-1.26,1.86-2.45,3.01-2.97,1.15-.52,1.96-.72,3.21-.51,1.25.20,3.22,1.39,3.71,2.66.49,1.27.30,2.22-.22,3.49-.53,1.26-1.49,2.32-3.01,2.97-1.53.65-2.96.60-4.24.10Z"
      />
    </g>
    <path
      className="eg-6"
      d="M398.24,249.44c-3.94,3.24-7.65,7.23-10.30,11.87-3.45-1.65-7.01-3.93-7.52-6.33-.94-4.43.98-9.04,3.78-10.93,2.80-1.89,5.29-1.97,8.58-1.13,1.60.40,3.72,3.49,5.46,6.52Z"
    />
    <path
      className="eg-6"
      d="M460.75,254.98c-.51,2.40-4.56,4.67-8.01,6.33-2.65-4.65-5.71-7.79-9.65-11.03,1.74-3.03,3.71-6.96,5.30-7.36,3.28-.84,5.78-.76,8.58,1.13,2.80,1.89,4.71,6.51,3.78,10.93Z"
    />
    <path
      className="eg-4"
      d="M396.20,279.29c.08-5.29-4.15-9.64-9.45-9.72-5.30-.08-9.67,4.14-9.76,9.42-.08,5.29,4.15,9.64,9.45,9.72,5.30.08,9.67-4.14,9.76-9.42Z"
    />
    <path d="M387.52,287.17c4.33.67,8.02-2.99,7.35-7.31-.41-2.69-2.61-4.88-5.30-5.29-4.33-.67-8.02,2.99-7.35,7.31.41,2.69,2.61,4.88,5.30,5.29Z" />
    <path
      className="eg-4"
      d="M463.45,279.29c.08-5.29-4.15-9.64-9.46-9.72-5.30-.08-9.67,4.14-9.76,9.42-.08,5.29,4.15,9.64,9.45,9.72,5.31.08,9.67-4.14,9.76-9.42Z"
    />
    <path d="M450.86,286.83c4.33.67,8.01-3,7.35-7.31-.41-2.69-2.61-4.88-5.3-5.29-4.33-.67-8.02,3-7.35,7.31.41,2.69,2.61,4.88,5.3,5.29Z" />
    <g>
      <path
        className="eg-5"
        d="M416.52,240.99c-8.32.39-22.67,7.16-22.02,11.66.13.88.84,1.79.96,1.95.95,1.20,2.40,1.85,4.17,2.31,1.86.48,3.34-.05,5.20.45,2.99.80,5.66,3.65,8.44,5.01,2.70,1.32,6.28,2.24,9.28,2.04,4.21-.29,8.78-3.95,16.43-6.38,2.51-.80,4.59-3.89,4.74-4.55.86-3.84-.59-4.59-1.03-5.15-3.47-4.38-10.71-6.99-14.06-7.52-2.29-.36-6.12-.02-9.66.09-1.10.03-2.13.07-2.44.09Z"
      />
      <path
        className="eg-9"
        d="M416.52,240.86c-3.68.19-7.33,1.29-10.73,2.64s-6.55,2.88-9.18,5.21c-.84.75-1.71,1.64-2.09,2.73-.45,1.28.21,2.56,1.08,3.51,1.46,1.59,3.91,2.28,6,2.30,1.34.01,2.62-.03,3.90.45,1.16.44,2.21,1.12,3.22,1.82,1.94,1.35,3.76,2.74,5.98,3.61s4.78,1.47,7.24,1.42c3.64-.07,6.99-2.18,10.19-3.67,1.15-.54,2.31-1.05,3.48-1.52s2.48-.85,3.69-1.33c1.65-.65,3.02-2.06,3.99-3.52.81-1.23,1.02-2.97.67-4.39-.25-.98-.98-1.67-1.62-2.40-2.64-2.98-6.49-4.89-10.21-6.14-1.50-.50-3.04-.92-4.63-1.02-2.54-.16-5.10.08-7.63.18-1.12.04-2.24.07-3.35.12-.16,0-.16.26,0,.25,2.33-.11,4.66-.19,6.98-.28,1.96-.08,3.96-.16,5.89.25,3.52.76,7.02,2.28,9.96,4.36,1.36.96,2.40,2.11,3.53,3.29,1.01,1.05,1.08,2.46.87,3.85-.25,1.63-1.34,2.91-2.56,3.98-.85.74-1.75,1.18-2.81,1.53-1.19.39-2.36.83-3.51,1.31-1.90.79-3.76,1.69-5.62,2.58-1.57.75-3.17,1.51-4.85,1.97-1.98.53-4.06.40-6.05,0-2.29-.46-4.55-1.28-6.52-2.55s-3.63-2.77-5.71-3.71c-.94-.42-1.92-.66-2.95-.69-1.30-.04-2.54.06-3.81-.30-1.97-.55-4.22-1.71-4.71-3.90-.24-1.07.42-2.10,1.09-2.88,2.04-2.36,5.06-3.93,7.85-5.22,3.34-1.54,6.90-2.76,10.53-3.34.79-.13,1.59-.22,2.39-.26.16,0,.16-.26,0-.25Z"
      />
    </g>
    <path
      className="eg-1"
      d="M428.07,244.25c0,3.17-3.57,4.56-7.60,4.56s-7.01-1.39-7.01-4.56,3.27-5.74,7.31-5.74,7.31,2.57,7.31,5.74Z"
    />
  </svg>
);
export { SvgEgg };
